import { lazy } from 'react';
import KeepAlive from 'react-activation';
import Loading from '../components/Loading';
import { Suspense } from "react";

const App = lazy(() => import('@/layouts/App'));
const Agent = lazy(() => import('@/pages/agent/Agent'));
const agentRoutes = [
    {
        path: "/layout",
        name: 'App',
        element: <App />,
        children: [
            {
                path: 'agent',
                name: '代理管理',
                element: <KeepAlive name='/layout/agent'>
                    <Suspense fallback={<Loading />}>
                        <Agent/>
                    </Suspense>
                </KeepAlive>
            },
        ]
    },
]
export default agentRoutes